import React, { Fragment } from 'react';

import { FormattedMessage } from 'react-intl';

import Lozenge from '@atlaskit/lozenge';
import { StatsigFeatureKeys } from '@atlassian/bitbucket-features';

import { PullRequestState } from 'src/components/types/src/pull-request';
import { useStatsigGate } from 'src/contexts/feature-provider';
import { useIntl } from 'src/hooks/intl';

import { messages } from './pull-request-activity-events.i18n';
import * as styles from './pull-request-event.styled';

const statusAppearance: {
  [k: string]: React.ComponentProps<typeof Lozenge>['appearance'];
} = {
  OPEN: 'inprogress',
  MERGED: 'success',
  DECLINED: 'removed',
  SUPERSEDED: 'moved',
  DRAFT: 'default',
};

const statusMessage = {
  OPEN: messages.openedEventLozenge,
  MERGED: messages.mergedEventLozenge,
  DECLINED: messages.declinedEventLozenge,
  SUPERSEDED: messages.supersededEventLozenge,
  DRAFT: messages.draftedEventLozenge,
};

type Props = {
  status: PullRequestState;
  draft?: boolean;
};

export const PullRequestStatusEntry = ({
  status,
  draft,
}: Props): JSX.Element => {
  const intl = useIntl();
  const areDraftPRsEnabled = useStatsigGate(StatsigFeatureKeys.bbcDraftPRs);
  const effectiveStatus =
    areDraftPRsEnabled && status === 'OPEN' && draft ? 'DRAFT' : status;
  const lozengeText = intl.formatMessage(statusMessage[effectiveStatus]);

  return (
    <Fragment>
      <Lozenge isBold appearance={statusAppearance[effectiveStatus]}>
        {lozengeText}
      </Lozenge>
      <styles.MessageText>
        <FormattedMessage {...messages.pullRequestContextMessage} />
      </styles.MessageText>
    </Fragment>
  );
};
